import { Button } from "@/components/ui/button";
import LoginDialog from "../Login/LoginDialog";
import { Link } from "react-router-dom";
import useUserStore from "@/stores/authentication/store";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Pagination,
  Navigation,
  Scrollbar,
  A11y,
} from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useMobileDetect } from "@/hooks";
import { renderCarouselIcons } from "@/components/customCarousel";
import { getCdnUrl } from "@/lib/utils";

const Dex = () => {
  const { isAuthenticated } = useUserStore();

  return (
    <div className="relative flex h-40 items-center overflow-hidden rounded-lg bg-gradient-to-l from-[#001E65] to-[#00113A] md:h-48">
      <div className="z-20 ml-4 text-white md:ml-8">
        <div className="mb-2 md:mb-6 ">
          <div className="w-12 text-2xl font-bold md:w-full">
            Decentralized Exchange (DEX)
          </div>
        </div>

        {isAuthenticated ? (
          <Link to="/shark-dex">
            <Button
              size="sm"
              className="w-[82px] rounded-lg bg-button-gradient-inverted py-1 text-sm font-semibold text-white md:px-6 lg:w-[120px] lg:py-4 lg:text-sm"
            >
              Exchange
            </Button>
          </Link>
        ) : (
          <LoginDialog
            initialActiveButton="signup"
            trigger={
              <Button
                size="sm"
                className="w-[82px] rounded-lg bg-button-gradient-inverted py-1 text-sm font-semibold text-white md:px-6 lg:w-[120px] lg:py-4 lg:text-sm"
              >
                Sign Up
              </Button>
            }
          />
        )}
      </div>
      <img
        src="/assets/home/card-dex.png"
        className="absolute right-0 z-10 w-[14rem] md:right-20 md:w-[32rem]"
      />
    </div>
  );
};

const Partnership = () => {
  return (
    <div className="flex items-start justify-start gap-4 rounded-xl bg-gradient-to-l from-[#001E65] to-[#00113A] p-4 lg:h-[302px] lg:w-[592px]">
      <div className="flex h-full w-1/2 flex-col justify-start gap-2 lg:gap-14 lg:p-4">
        <div className="flex h-32 flex-col justify-start gap-2 text-white lg:gap-4">
          <h3 className="text-3xl font-[500]">Partnership</h3>
          <p className="text-card-text lg:text-2xl">
            Become a Sharkroll Affiliate and start earning today
          </p>
        </div>
        <Link to="/partnership-program">
          <Button
            size="sm"
            className="w-[7rem] rounded-lg bg-button-gradient-inverted text-sm font-semibold text-white md:px-6 lg:w-[120px] lg:py-4 lg:text-sm"
          >
            Apply Now
          </Button>
        </Link>
      </div>

      <img
        src={getCdnUrl("assets/home/card-partnership.png")}
        className="h-[8rem] w-[14rem] translate-y-5 lg:h-[14rem] lg:w-[18rem] lg:-translate-y-5 lg:self-center"
      />
    </div>
  );
};

const Referral = () => {
  return (
    <div className="flex items-start justify-start gap-4 rounded-xl bg-gradient-to-l from-[#001E65] to-[#00113A] p-4 lg:h-[302px] lg:w-[592px]">
      <div className="flex h-full w-1/2 flex-col justify-start gap-2 lg:gap-14 lg:p-4">
        <div className="flex h-32 flex-col justify-start gap-2 text-white lg:gap-4">
          <h3 className="text-3xl font-[500]">Referral</h3>
          <p className="text-card-text lg:text-2xl">
            Refer friends, earn rewards now!
          </p>
        </div>{" "}
        <Link to="/profile?tab=referrals">
          <Button className="rounded-lg bg-button-gradient-inverted py-1 text-sm font-semibold text-white md:px-6 lg:w-[120px] lg:py-4 lg:text-sm">
            See Details
          </Button>
        </Link>
      </div>

      <img
        src={getCdnUrl("assets/home/card-referral.png")}
        className="h-[8rem] w-1/2 translate-y-5 lg:h-[12rem] lg:w-1/2 lg:-translate-x-6 lg:translate-y-5 lg:self-center"
      />
    </div>
  );
};

const EarnNow = () => {
  const { isAuthenticated } = useUserStore();
  const isMobile = useMobileDetect();

  return (
    <div className="flex w-full flex-col gap-4">
      {!isMobile ? (
        <div className="flex justify-between">
          <Partnership />
          <Referral />
        </div>
      ) : (
        <div className="w-full">
          <Swiper
            slidesPerView={1}
            style={{
              paddingBottom: isMobile ? "32px" : 0,
            }}
            centeredSlides={false}
            modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
            freeMode={true}
            loop={true}
            autoHeight
            pagination={{
              clickable: true,
              type: "custom",
              renderCustom: renderCarouselIcons,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            speed={1300}
            spaceBetween={8}
          >
            <SwiperSlide key="partnership">
              <Partnership />
            </SwiperSlide>
            <SwiperSlide key="referral">
              <Referral />
            </SwiperSlide>
          </Swiper>
        </div>
      )}

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Link to="/casino/lobby?tab=lobby">
          {/* Desktop Image */}
          <img
            className="-mb-4 hidden w-full overflow-hidden lg:block"
            src={getCdnUrl("assets/home/dive-in-the-water-is-warm.png")}
            alt="dive in"
          />

          {/* Mobile Image */}
          <img
            className="block w-full overflow-hidden lg:hidden"
            src={getCdnUrl("assets/home/dive-in-the-water-is-warm-mobile.png")}
            alt="dive in"
          />
        </Link>
        <Link to="/casino/lobby?tab=lobby">
          {/* Desktop Image */}
          <img
            className="-mb-4 hidden w-full overflow-hidden lg:block"
            src={getCdnUrl("assets/home/happy-fishing-bag-a-whopper.png")}
            alt="happy fishing"
          />

          {/* Mobile Image */}
          <img
            className="block w-full overflow-hidden lg:hidden"
            src={getCdnUrl("assets/home/happy-fishing-bag-a-whopper-mobile.png")}
            alt="happy fishing"
          />
        </Link>
      </div>
    </div>
  );
};

export default EarnNow;
